
export default {
    code:'BES_NZ_AVIATION_FESTIVAL_AMERICAS_2023',
    content:{
        transaction: {
            headerText: 'Congratulations! You\'ve made a difference. Here are the details:',
            items: ['impactPanel']
        },
    }
}